import { trackEvent } from '@finn-no/pulse-sdk';
import { getConfig } from '../config';
import { inscreen } from './lazy';
import { escape } from './component/helpers';

const unsafeVertical = getConfig()?.vertical;
const unsafeSubVertical = getConfig()?.subvertical;
const unsafeId = getConfig()?.contentMarketing?.id;
const vertical = unsafeVertical ? escape(unsafeVertical) : '';
const subVertical = unsafeSubVertical ? escape(unsafeSubVertical) : '';
const id = unsafeId ? escape(unsafeId) : '';

const type = 'Content';

export function logCreativeLoad(position: string) {
    trackEvent({
        type: 'Load',
        name: 'Display ad',
        object: {
            id: id,
            type: 'DisplayAd',
            adType: type,
            adPosition: position,
            adCreative: id,
        },
        vertical: {
            name: vertical,
            subVertical: subVertical,
        },
    });
    const element = document.getElementById(position);
    if (element) {
        observeCreative(element);
    }
}

function logCreativeView(element: Element) {
    const position = element.id;
    trackEvent({
        type: 'View',
        name: 'Display ad',
        object: {
            id: id,
            type: 'DisplayAd',
            adType: type,
            adPosition: position,
            adCreative: id,
        },
        vertical: {
            name: vertical,
            subVertical: subVertical,
        },
    });
}

export function logCreativeClick(
    position: string,
    target: string,
    provider: string,
) {
    trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Display ad',
        object: {
            id: id,
            type: 'DisplayAd',
            adType: type,
            adPosition: position,
            adCreative: id,
        },
        vertical: {
            name: vertical,
            subVertical: subVertical,
        },
        target: {
            id: target,
            referralCommission: false,
            type: 'ExternalContent',
            provider: provider,
        },
    });
}

function observeCreative(ele: HTMLElement) {
    inscreen(ele, logCreativeView, {
        timeout: 1000,
    });
}
